import Grid from '@mui/material/Grid';

import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import Button, { type ButtonContent } from '@/components/OldButton/OldButton';
import type {
  Contentful,
  FrontifyImageContent,
} from '@/contentful/contentful-exports';
import { getFrontifyBackgroundImageUrl } from '@/utils/frontify';

import useStyles from './HeroTwoThirdsImage.styles';

export interface HeroTwoThirdsImageContent extends Contentful {
  fields: {
    title: string;
    body: string;
    image: FrontifyImageContent[];
    ctaButton: ButtonContent;
    imageAlignment: 'left' | 'right';
  };
}

interface Props {
  content: HeroTwoThirdsImageContent;
}

export default function Hero({ content }: Props) {
  const { title, body, image, ctaButton, imageAlignment } = content.fields;
  const imageUrl = image[0].preview_url;
  const { classes } = useStyles();

  return (
    <GridContainer
      gridProps={{
        className: classes.heroContainer,
        style: {
          flexDirection: imageAlignment === 'left' ? 'row' : 'row-reverse',
        },
      }}
    >
      <Grid
        className={classes.heroSection}
        style={{
          backgroundImage: getFrontifyBackgroundImageUrl(imageUrl, 1440),
        }}
        size={{
          md: 7,
          xs: 12,
        }}
      />
      <Grid
        className={
          ctaButton ? classes.heroTextContainer : classes.heroTextContainerNoCTA
        }
        size={{
          md: 5,
          xs: 12,
        }}
      >
        <h1 className={classes.heroTitle}>{title}</h1>
        {body && <p className={classes.heroBody}>{body}</p>}
        {ctaButton && (
          <div className={classes.heroButtom}>
            <Button {...ctaButton?.fields} />
          </div>
        )}
      </Grid>
    </GridContainer>
  );
}
